import Vue from "vue";
import VueRouter from "vue-router";

// let UItype = sessionStorage.getItem('screenModal') //1:原来的UI  2:新UI
// 引入组件
// import head from "../components/head";
const index = r => require.ensure([], () => r(require('../pages/index')), 'index');
const playerQuestions = r => require.ensure([], () => r(require(sessionStorage.getItem('screenModal') == 2 ? '../pages/UItwo/playerQuestions' : '../pages/playerQuestions')), 'playerQuestions');

const scoring = r => require.ensure([], () => r(require(sessionStorage.getItem('screenModal') == 2 ? '../pages/UItwo/scoring' : '../pages/scoring')), 'scoring');
const playerRanking = r => require.ensure([], () => r(require(sessionStorage.getItem('screenModal') == 2 ? '../pages/UItwo/playerRanking' : '../pages/playerRanking')), 'playerRanking');
const countdown = r => require.ensure([], () => r(require(sessionStorage.getItem('screenModal') == 2 ? '../pages/UItwo/countdown' : '../pages/countdown')), 'countdown');
const totalScore_player = r => require.ensure([], () => r(require(sessionStorage.getItem('screenModal') == 2 ? '../pages/UItwo/totalScore_player' : '../pages/totalScore_player')), 'totalScore_player');
// const playerRankingSplit = r => require.ensure([], () => r(require('../pages/playerRankingSplit')), 'playerRankingSplit');
const playerRankingSplit = r => require.ensure([], () => r(require(sessionStorage.getItem('screenModal') == 2 ? '../pages/UItwo/playerRankingSplit' : '../pages/playerRankingSplit')), 'playerRankingSplit');
const draw = r => require.ensure([], () => r(require(sessionStorage.getItem('screenModal') == 2 ? '../pages/UItwo/draw' : '../pages/draw')), 'draw');



// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

const routes = [{
    path: "/pages/index",
    component: index
  }, {
    path: "/pages/playerQuestions",
    component: playerQuestions
  }, {
    path: "/pages/scoring",
    component: scoring
  }, {
    path: "/pages/playerRanking",
    component: playerRanking
  }, {
    path: "/pages/countdown",
    component: countdown
  }, {
    path: "/pages/totalScore_player",
    component: totalScore_player
  }, {
    path: "/pages/playerRankingSplit",
    component: playerRankingSplit
  }, {
    path: "/pages/draw",
    component: draw
  },
  // 重定向
  {
    path: '/',
    redirect: '/pages/index'
  }
]
//console.log('routes', routes)
var router = new VueRouter({
  routes
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js